import { UserAuthModal } from '@on3/ui-lib/components/Modal/User/Auth';
import { UserCancelSaveModal } from '@on3/ui-lib/components/Modal/User/CancelSave';
import { UserJoinModal } from '@on3/ui-lib/components/Modal/User/Join';
import { UserJoinSuccessModal } from '@on3/ui-lib/components/Modal/User/Join/Success';
import { UserPaymentMethodModal } from '@on3/ui-lib/components/Modal/User/PaymentMethod';
import { type ComponentProps } from 'react';

export type UserModalType =
  | 'user.auth'
  | 'user.join'
  | 'user.join.success'
  | 'user.cancel-save'
  | 'user.payment-method';

export interface UserModalPropsMap {
  'user.auth': ComponentProps<typeof UserAuthModal>;
  'user.join': ComponentProps<typeof UserJoinModal>;
  'user.join.success': ComponentProps<typeof UserJoinSuccessModal>;
  'user.cancel-save': ComponentProps<typeof UserCancelSaveModal>;
  'user.payment-method': ComponentProps<typeof UserPaymentMethodModal>;
}

export const userModals = {
  'user.auth': UserAuthModal,
  'user.join': UserJoinModal,
  'user.join.success': UserJoinSuccessModal,
  'user.cancel-save': UserCancelSaveModal,
  'user.payment-method': UserPaymentMethodModal,
};
